import { AffiliateProductCardDefault } from '@/app_components/AffiliateProductCard/AffiliateProductCardDefault';
import type { FortuneProductCard } from '@/app_components/AffiliateProductCard/types';
import { ProsCons } from '@/app_components/ProsCons';
import type { ParserProps } from '@/app_lib/htmlParser/types';

export const FortuneCustomBlock = ({ domNode }: ParserProps) => {
  const { attribs } = domNode;
  const customBlock = attribs['data-block-id'];

  let blockValue: FortuneProductCard | undefined;
  let blockIndex: number | undefined;
  if (attribs['data-value'] && attribs['data-card-index']) {
    blockValue = JSON.parse(attribs['data-value']) as FortuneProductCard;
    blockIndex = Number(attribs['data-card-index']);
  }

  switch (customBlock) {
    case 'affiliate-product-card':
      // TODO: Uncomment the code below once an optimizely test is created for affiliate_product_card
      // <AbTest
      //   flagName='affiliate_product_card'
      //   variants={{
      //     control: <AffiliateProductCardDefault productCard={blockValue as FortuneProductCard} />,
      //     off: null,
      //     variantA: <div>VariantA</div>,
      //   }}
      // />
      if (blockValue === undefined || blockIndex === undefined) {
        return null;
      }
      return (
        <AffiliateProductCardDefault
          index={blockIndex}
          productCard={blockValue}
        />
      );
    case 'proscons':
      return (
        <ProsCons
          domNode={domNode}
          reactNode={undefined}
        />
      );

    default:
      return null;
  }
};
